export const UPLOAD_FILE_TYPE = {
  IMAGE_AND_PDF: "image/png, image/jpeg,.pdf",
  IMAGE: "image/png, image/jpeg",
  PDF: "pdf",
}
